module.exports = __webpack_public_path__ + "assets/media/new-business.38199f13.svg";